module.exports = __webpack_public_path__ + "static/media/budgets.612725bb.jpg";